// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_DCK","cls2":"ProfilePdfPackCard-cls2_Hqk ProfilePdfPackCard-cls1_DCK"};